import { render, staticRenderFns } from "./detail-filter.vue?vue&type=template&id=d6cf8240"
import script from "./detail-filter.vue?vue&type=script&lang=js"
export * from "./detail-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports